import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Platform, ActionSheetController } from '@ionic/angular';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Constants } from 'app/utility/constants';
import { loadImageElement, normalizeImageFileToDataUrl } from 'app/utility/image-heic.util';

@Component({
    selector: 'app-image-input',
    templateUrl: './image-input.component.html',
    styleUrls: ['./image-input.component.scss'],
    host: {
        "(click)": "onClick($event)"
    },
    standalone: false
})
export class ImageInputComponent implements OnInit
{

	@Input() src: string;
	@Input() id: string;
	@Input() alt: string;

	@Input() label: string;
	@Input() required: boolean = false;
	@Input() allowDelete: boolean = false;

	@Output() mcChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() newSrc: string;

	@ViewChild('inputcamera') cameraInput: ElementRef;


	showPlaceholder: boolean = false;
	maxWidth: number = 1280;
	maxHeight: number = 960;
	maxDimension: number = 1280;
	externalImage: boolean = false;

	constructor(
		public platform: Platform,
		private actionSheetController: ActionSheetController,
		private sanitizer: DomSanitizer,
		private changeDetectorRef: ChangeDetectorRef,
	)
	{
		this.newSrc = '';
	}

	ngOnInit()
	{
		if (this.src == '' || this.src == null)
		{
			this.showPlaceholder = true;
		}
		else
		{
			this.showPlaceholder = false;
		}

		this.externalImage = (this.src && this.src.startsWith("https:") && !this.src.startsWith(Constants.ApiUrl))
	}
	
	onClick(e)
	{
		// console.log(e);
		this.presentActionSheet();
	}
	async presentActionSheet()
	{
		if (this.platform.is('cordova'))
		{
			var buttons = []

			buttons.push(
				{
					text: 'Camera',
					icon: 'camera',
					role: '',
					handler: () =>
					{
						this.takePicture(CameraSource.Camera)
					}
				}
			);
			buttons.push(
				{
					text: 'Device Library',
					icon: 'images',
					role: '',
					handler: () =>
					{
						this.takePicture(CameraSource.Photos);
					}
				},
			);
			buttons.push(
				{
					text: 'Cancel',
					icon: 'close',
					role: 'cancel',
					handler: () =>
					{
						// console.log('Cancel clicked')
					}
				}
			);
			const actionSheet = await this.actionSheetController.create({
				header: "Select Image source",
				buttons: buttons
			});
			await actionSheet.present();
		}
		else
		{
			this.launchPwaImagePicker();

		}
	}

	getSafeSrc(url: string)
	{
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}

	async takePicture(sourceType: CameraSource)
	{
		const image = await Camera.getPhoto({
			quality: 100,
			allowEditing: false,
			resultType: CameraResultType.Uri,
			height: this.maxHeight,
			width: this.maxWidth,
			correctOrientation: true,
			source: sourceType,
			saveToGallery: false
		});
		var imageToUpload = image.webPath;
		// var imgsrc = this.sanitizer.bypassSecurityTrustResourceUrl(image && (image.webPath));
		// let blob = await fetch(image.webPath).then(r => r.blob());
		setTimeout(() =>
		{
			this.showPlaceholder = false;
			this.src = imageToUpload;
			this.newSrc = imageToUpload;
			this.changeDetectorRef.detectChanges();
			this.mcChange.emit(imageToUpload);
		}, 500);
	}


	async launchPwaImagePicker()
	{
		this.newSrc = '';
		const element = this.cameraInput.nativeElement as HTMLInputElement;
		// this.src = '';
		// this.showPlaceholder = true;
		this.changeDetectorRef.detectChanges();
		element.onchange = async () =>
		{
			if (!element.files || element.files.length === 0)
			{
				return;
			}

			try
			{
				const file = element.files[0];
				const source = await normalizeImageFileToDataUrl(file);
				const img = await loadImageElement(source);

				const elem = document.createElement('canvas');

				const ctx = elem.getContext('2d');
				const maxWidth: number = 1280;
				const width = maxWidth;
				const height = width;
				var scaledWidth = width;
				var scaledHeight = height;

				var scaleFactor = width / img.width;
				if (img.height > img.width)
				{
					scaleFactor = height / img.height;
					scaledWidth = img.width * scaleFactor;
				}
				else
				{
					scaledHeight = img.height * scaleFactor;
				}


				//resize biggest edge to the "width" dimension (this fixes issues with portrait uploads)

				elem.width = scaledWidth;
				elem.height = scaledHeight;

				ctx.drawImage(img, 0, 0, scaledWidth, scaledHeight);
				var dataURL = ctx.canvas.toDataURL('image/jpeg', 1);
				this.changeDetectorRef.detectChanges();
				this.showPlaceholder = false;
				this.mcChange.emit(dataURL);
			}
			catch (error)
			{
				console.error(error);
			}

			element.value = "";
		};

		this.cameraInput.nativeElement.click();
	}

	dataURItoBlob(dataURI: string)
	{
		// convert base64 to raw binary data held in a string
		// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
		var byteString = atob(dataURI.split(',')[1]);

		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);

		// create a view into the buffer
		var ia = new Uint8Array(ab);

		// set the bytes of the buffer to the correct values
		for (var i = 0; i < byteString.length; i++)
		{
			ia[i] = byteString.charCodeAt(i);
		}

		// write the ArrayBuffer to a blob, and you're done
		var blob = new Blob([ab], { type: mimeString });
		return blob;

	}

	public showPlaceholderImage(): boolean
	{
		return this.showPlaceholder;
	}

	public deletePhoto(event)
	{
		event.stopPropagation();
		this.src = '';
		this.showPlaceholder = true;
		this.mcChange.emit('');
		this.changeDetectorRef.detectChanges();
	}
}
